module.exports = __webpack_public_path__ + "img/homeNew.7fab7a71.png";